import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Pages keep the design's plain `<a href>` markup; same-origin links to panel routes are turned
 * into client-side navigations here (no reload), everything else behaves like a normal link.
 */
export function LinkInterceptor() {
  const navigate = useNavigate();
  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = (e.target as Element | null)?.closest?.('a');
      if (!a || a.hasAttribute('download') || (a.target && a.target !== '_self')) return;
      const href = a.getAttribute('href');
      if (!href || href.startsWith('#') || /^[a-z][a-z0-9+.-]*:/i.test(href) || href.startsWith('//')) return;
      if (href.startsWith('/api/') || href.startsWith('/docs/')) return;
      e.preventDefault();
      navigate(href);
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, [navigate]);
  return null;
}
